import { Feature, flags, FlagType } from '../flags/flags'

export const CS_CLARITY_400_URL = 'https://files.acresoftware.com/assets/fonts/cs-clarity/cs-clarity-v1-400.woff2'

export const injectFontPreload = (href: string) => {
  const link = document.createElement('link')
  link.rel = 'preload'
  link.as = 'font'
  link.type = 'font/woff2'
  // Font fetches are always CORS-mode; without a matching crossorigin attribute the
  // preload cache entry is unusable and the browser downloads the font twice
  link.crossOrigin = 'anonymous'
  link.href = href
  document.head.appendChild(link)
}

// A static <link rel="preload"> downloads unconditionally, so the preload must only be
// injected when either app's score font flag selects the CS Clarity theme — score_font
// for broker CRM/introducers, score_font_cp for the client portal. The @font-face
// declarations stay static in each app's index.html — they are lazy and fetch nothing
// until a rendered rule uses the family. Only the 400 weight is preloaded; the 700 weight
// is left to the lazy @font-face fetch, which happens when bold text first renders.
export const preloadCsClarityFont = () => {
  if (!flags[FlagType.Feature][Feature.ScoreFont] && !flags[FlagType.Feature][Feature.ScoreFontCP]) return

  injectFontPreload(CS_CLARITY_400_URL)
}
